import React from "react";
import { Button, Popconfirm } from "antd";
import { CancelWhiteSVG, PrintColorWhiteSVG, SaveWhiteIconSVG } from "assets";
import { PauseOutlined } from "@ant-design/icons";

const Save = (handleFunc, name?: string): JSX.Element => {
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
    >
      {name ?? "Lưu lại"}
    </Button>
  );
};

const AddOthorK = (handleFunc, name?: string): JSX.Element => {
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
    >
      Thêm mới Ortho K
    </Button>
  );
};

const SaveAndPrint = (handleFunc?, name?): JSX.Element => {
  // const {disable} =
  return (
    <Button
      className="btn-sub"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<PrintColorWhiteSVG />}
    >
      {name}
    </Button>
  );
};

const Completed = (handleFunc, name, disable?: boolean): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      type="primary"
      disabled={disable}
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
    >
      {name}
    </Button>
  );
};

const CompletedPK = (handleFunc): JSX.Element => {
  return (
    <Popconfirm
      title="Bạn có muốn hoàn thành khám chữa bệnh?"
      onConfirm={handleFunc}
    >
      <Button className="btn-sub" type="primary" icon={<SaveWhiteIconSVG />}>
        Hoàn thành KCB
      </Button>
    </Popconfirm>
  );
};

const NextPatient = (handleFunc, disable?: boolean): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      type="primary"
      htmlType="submit"
      disabled={disable}
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
    >
      Bệnh nhân tiếp theo
    </Button>
  );
};

const Cancel = (handleFunc, trangThai?): JSX.Element => {
  return (
    <Popconfirm
      title={
        trangThai == 2
          ? "Phiếu khám chưa hoàn thành bạn có chắc chắn muốn hủy khám."
          : "Bạn có chắc chắn muốn hủy khám"
      }
      onConfirm={handleFunc}
    >
      <Button
        className="custom-btn"
        type="primary"
        htmlType="submit"
        danger
        icon={<CancelWhiteSVG />}
      >
        Hủy khám
      </Button>
    </Popconfirm>
  );
};

const Agree = (handleFunc, disable?: boolean): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      disabled={disable}
      onClick={handleFunc}
    >
      Đồng ý PT
    </Button>
  );
};
const DisAgree = (handleFunc, disable?: boolean): JSX.Element => {
  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={disable}
      danger
      onClick={handleFunc}
    >
      Từ chối PT
    </Button>
  );
};

const Pause = (handleFunc, disable?: boolean): JSX.Element => {
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      disabled={disable}
      icon={<PauseOutlined />}
    >
      Tạm dừng
    </Button>
  );
};

const PrintCertificate = (handleFunc: () => void): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      type="primary"
      onClick={handleFunc}
      icon={<PrintColorWhiteSVG />}
    >
      In giấy CN
    </Button>
  );
};

const AddService = (handleFunc: () => void): JSX.Element => {
  return (
    <Button className="btn-sub" type="primary" onClick={handleFunc}>
      Chọn gói DV
    </Button>
  );
};

export {
  Save,
  Cancel,
  Completed,
  NextPatient,
  Pause,
  SaveAndPrint,
  Agree,
  DisAgree,
  PrintCertificate,
  CompletedPK,
  AddService,
  AddOthorK,
};
